import {styled, ThinScrollbar} from "@reside/ui";

/** Shared vertical + horizontal scroll region for dashboard grid and list views (minimap pairs with this). */
export const DashboardBoardScrollShell = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 1px; /* flex child needs bounded height so overflow:auto scrolls */
  width: 100%;
`;

export const DashboardBoardScrollArea = styled(ThinScrollbar)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  /* iOS Safari: enable momentum/native scroll in overflow containers. */
  -webkit-overflow-scrolling: touch;
  /* Chromium/Safari: hide native horizontal scrollbar; minimap replaces it. */
  &::-webkit-scrollbar:horizontal {
    height: 0;
  }
`;
